import { InjectionToken } from '@angular/core';

export interface ImageCroppingConfig {
  croppedWidthPX: number;
  croppedHeightPX: number;
  toolsColor?: string;
  backdropColor?: string;
}

export const IMAGE_CROPPING_GLOBAL_CONFIG =
  new InjectionToken<ImageCroppingConfig>('image-cropping-global-config');
